const logout = () => {
  const jwtDomain = import.meta.env.VITE_TSD_DOMAIN;
  if (!jwtDomain) throw new Error("Missing VITE_TSD_DOMAIN env variable");

  document.cookie = `jwt=; path=/; domain=${jwtDomain}; max-age=0`;
};

export default logout;
